import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiFire } from 'react-icons/hi'; // An icon for the header
import axiosInstance from '../../utils/axiosInstance';

const TopViewedSidebar = () => {
  const [topBlogs, setTopBlogs] = useState([]);

  useEffect(() => {
    const fetchTopBlogs = async () => {
      try {
        const { data } = await axiosInstance.get('/blogs/top-viewed');
        setTopBlogs(data.slice(0, 17));
      } catch (error) {
        console.error('Failed to fetch top viewed blogs:', error);
      }
    };
    fetchTopBlogs();
  }, []);

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <div className="flex items-center gap-2 mb-4 p-2 bg-red-600 text-white rounded">
        <HiFire size={20} />
        <h3 className="font-bold text-lg">TOP VIEWED</h3>
      </div>
      <ul className="space-y-4">
        {topBlogs.length>0 && topBlogs.map(blog => {
          const date = new Date(blog.created_at);
          const day = date.getDate();
          const month = date.toLocaleString('default', { month: 'short' });

          return (
            <li key={blog.id} className="flex items-start gap-3">
              <div className="flex flex-col items-center justify-center bg-gray-100 p-2 rounded text-center">
                <span className="text-xl font-bold text-red-600">{day}</span>
                <span className="text-xs text-gray-600 uppercase">{month}</span>
              </div>
              <div className="flex-1">
                <Link to={`/blog/${blog.id}`} className="font-semibold text-gray-800 hover:text-indigo-600 transition-colors">
                  {blog.title}
                </Link>
                <p className="text-xs text-gray-500 mt-1">
                  {blog.clicks} views
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TopViewedSidebar;